export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";